import { Block } from "@block";
import { useNavigation } from "@react-navigation/core";
import { StackActions } from "@react-navigation/routers";
import { showModal } from "app/modules/modal-management/reducer/action";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { ItemCompleteProps } from "app/shared/components/modal/auto-complete/auto-complete";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { EBINQUIRY } from "app/shared/services/services-model.type";
import { spacing } from "app/shared/styles/spacing";
import { formatDate } from "app/shared/util/common";
import { formatNumberThousand } from "app/shared/util/format-currency";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import { createWs } from "app/shared/util/xlsx-utils";
import moment from "moment";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import XLSX from "xlsx";
import { fetchTransHistoryRequest, setTransHistory } from "../reducer/actions";
import { getPendingTransHistorySelector, getResTransHistorySelector, getTransHistorySelector } from "../reducer/selectors";
import FilterTransactionTable, { FormFilterTransHistory } from "./filter-transaction-history-table/filter-transaction-table.web";
import TransactionTable, { DataTransHistoryTableProps } from "./filter-transaction-history-table/transaction-table";

export interface TransStatus {
  ID: string;
  NAME: {
    vi: string;
    en: string;
  };
}

enum ActionFilter {
  Search,
  Download,
  DataTable,
  Reset,
}

// function getSheetData(data: any = [], header: any = []) {
//   var fields = Object.keys(data[0]);
//   var sheetData = data.map(function (row: any) {
//     return fields.map(function (fieldName) {
//       return row[fieldName] ? row[fieldName] : "";
//     });
//   });
//   sheetData.unshift(header);
//   return sheetData;
// }

const ListTransactionHistory = () => {
  const { dispatch } = useNavigation();
  const { i18n, t } = useTranslation();
  const dispatchStore = useDispatch();
  const isDesktop = useDesktopMediaQuery();

  const transHistoryStore = useSelector(getTransHistorySelector);
  const listTransHistory = useSelector(getResTransHistorySelector);
  const pending = useSelector(getPendingTransHistorySelector);

  const [globalModalRef] = React.useState<React.RefObject<any>>(createGlobalModal());
  const [dataTransHistory, setDataTransHistory] = React.useState<DataTransHistoryTableProps[]>([]);
  const [isShowTable, setShowTable] = React.useState<boolean>(false);
  const [isSearch, setIsSearch] = React.useState<boolean>(false);
  const [dataList, setDataList] = React.useState<DataTransHistoryTableProps[]>([]);
  const [statusArray, setStatusArray] = React.useState<ItemCompleteProps[]>([]);

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_ACCOUNT_MANAGEMENT));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("ACC_QUAN_LY_TAI_KHOAN"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("ACC_LICH_SU_GIAO_DICH"),
      onPressSubtitle: () => {},
    },
  ];

  const exportToCSV = (sheetData: DataTransHistoryTableProps[], fileName: any) => {
    const fields = [
      "id",
      "FORMAT_TRANSACTION_DATE",
      "RQSTSEQ",
      "CURRENCY_TRANSACTION_AMOUNT",
      "CURRENCY_TOTAL_FEE_AMOUNT",
      "TRANSACTION_DESCRIPTION",
      "CREDIT_ACCOUNT_NUMBER",
      "CREDIT_ACCOUNT_NAME",
      "CREDIT_BANK_NAME",
      "status_name",
    ];
    const retructionArray = sheetData.map((u: DataTransHistoryTableProps) => {
      delete u.ADDRESS;
      delete u.ADDITIONAL_FEE_AMOUNT;
      delete u.CREDIT_AMOUNT;
      delete u.DEBIT_AMOUNT;
      delete u.FEE_TYPE;
      delete u.MAIN_FEE_VAT_AMOUNT;
      delete u.OTHER_FEE_AMOUNT;
      delete u.VAT_FEE_AMOUNT;
      delete u.CORE_STATUS;
      delete u.CORE_TRANSACTION_DATE;
      delete u.CREDIT_BRANCH_NAME;
      delete u.DEBIT_ACCOUNT_CURRENCY;
      delete u.DEBIT_ACCOUNT_NAME;
      delete u.DEBIT_ACCOUNT_NUMBER;
      delete u.DEBIT_BANK_NAME;
      delete u.DEBIT_BRANCH_NAME;
      delete u.STATUS;
      delete u.TRANSACTION_ALIAS;
      delete u.TRANSACTION_POSTING;
      delete u.TYPE;
      delete u.USERPROFILE;
      delete u.TRANSACTION_AMOUNT;
      delete u.TOTAL_FEE_AMOUNT;
      delete u.TRANSACTION_DATE;
      return u;
    });
    const titles = {
      id: "#",
      FORMAT_TRANSACTION_DATE: t("ACC_NGAY_LAP_LENH"),
      RQSTSEQ: t("ACC_SO_THAM_CHIEU"),
      CURRENCY_TRANSACTION_AMOUNT: t("ACC_SO_TIEN") + " (" + t("COMMON_VND") + ")",
      CURRENCY_TOTAL_FEE_AMOUNT: t("ACC_PHI_GD") + " (" + t("COMMON_VND") + ")",
      TRANSACTION_DESCRIPTION: t("ACC_MO_TA"),
      CREDIT_ACCOUNT_NUMBER: t("ACC_TK_NHAN"),
      CREDIT_ACCOUNT_NAME: t("ACC_TEN_NGUOI_NHAN"),
      CREDIT_BANK_NAME: t("ACC_NGAN_HANG_NHAN"),
      status_name: t("ACC_TRANG_THAI"),
    };
    // Create book new;
    var wb = XLSX.utils.book_new();
    const ws = createWs(retructionArray, fields, titles);

    // Add Row to Sheet
    XLSX.utils.book_append_sheet(wb, ws, "sample");
    XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };
  const handleOnChange = (type: ActionFilter) => (_values: FormFilterTransHistory) => {
    switch (type) {
      case ActionFilter.Download:
        if (dataTransHistory.length > 0) {
          const fileName =
            "report_" +
            moment(_values.fromDate, "DD/MM/YYYY").format("DDMMYYYY").toString() +
            "_" +
            moment(_values.toDate, "DD/MM/YYYY").format("DDMMYYYY").toString();
          exportToCSV(dataTransHistory, fileName);
        } else {
          dispatchStore(
            showModal({
              modalProps: {
                open: true,
                message: t("CC_KHONG_CO_GIAO_DICH_NAO"),
              },
              modalType: "alert",
            }),
          );
        }
        break;
      case ActionFilter.Search:
        requestSearch(_values);
        break;
      case ActionFilter.Reset:
        if (isSearch) setIsSearch(false);
        if (isShowTable) setShowTable(false);
        if (listTransHistory?.LIST_EBTRANSFER) dispatchStore(setTransHistory({ ...transHistoryStore, responseTransHistory: undefined }));
        break;
      default:
        break;
    }
  };

  const getDateFromTable = React.useCallback((_data: DataTransHistoryTableProps[]) => {
    setDataTransHistory(_data);
  }, []);

  const closeModalInput = () => {
    globalModal.hide(globalModalRef);
  };

  const showModalInput = (content: JSX.Element) => {
    globalModal.show(content, globalModalRef);
  };

  const requestSearch = (data: FormFilterTransHistory) => {
    if (isShowTable) setShowTable(false);
    dispatchStore(fetchTransHistoryRequest(data));
  };

  const handlerStatusArray = React.useCallback(
    (transJson?: any) => {
      if (transJson) {
        const filters: TransStatus[] = transJson.STATUS;
        if (filters.length > 0) {
          const list: ItemCompleteProps[] = [];
          filters.forEach((item) => {
            const name = i18n.language === "en" ? item.NAME.en : item.NAME.vi;
            const obj: ItemCompleteProps = { label: name, value: item.ID };
            list.push(obj);
            return;
          });
          setStatusArray(list);
        }
      }
    },
    [i18n.language],
  );

  const loadTransStatusJson = React.useCallback(() => {
    return new Promise(async (resolve) => {
      if (!(statusArray.length > 0)) {
        let transJson = await import("app/shared/util/data-json/transaction-status.json");
        handlerStatusArray(transJson);
      }
      resolve(0);
    });
  }, [handlerStatusArray, statusArray.length]);

  const getTransStatusName = React.useCallback(
    (status?: string) => {
      if (statusArray && status) {
        const filters: ItemCompleteProps[] = statusArray.filter((item: ItemCompleteProps) => {
          return item.value === status;
        });
        if (filters.length) return filters[0].label;
      }
      return t("Chưa xác định");
    },
    [statusArray, t],
  );

  const getDataTable = React.useCallback(
    (_data?: EBINQUIRY[]) => {
      if (_data && _data?.length > 0) {
        _data.map((obj: DataTransHistoryTableProps, index: number) => {
          const statusName = getTransStatusName(obj.STATUS);
          obj.id = String(index + 1);
          obj.CURRENCY_TRANSACTION_AMOUNT = formatNumberThousand(obj.TRANSACTION_AMOUNT);
          obj.CURRENCY_TOTAL_FEE_AMOUNT = formatNumberThousand(obj.TOTAL_FEE_AMOUNT);
          obj.FORMAT_TRANSACTION_DATE = formatDate(obj.TRANSACTION_DATE);
          obj.status_name = statusName;
          return obj;
        });
        return _data;
      }
      return [];
    },
    [getTransStatusName],
  );

  React.useEffect(() => {
    loadTransStatusJson();
  }, [loadTransStatusJson]);

  React.useEffect(() => {
    const data: DataTransHistoryTableProps[] = getDataTable(listTransHistory?.LIST_EBTRANSFER);
    setDataList(data);
  }, [getDataTable, listTransHistory]);

  React.useEffect(() => {
    if (pending && !isSearch) {
      setIsSearch(true);
    }
  }, [pending, isSearch]);

  React.useEffect(() => {
    if (!pending && isSearch && !isShowTable) {
      setIsSearch(false);
      setShowTable(true);
    }
  }, [pending, isShowTable, isSearch]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("ACC_LICH_SU_GIAO_DICH")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <FilterTransactionTable
            onChangeDownloadTransHistory={handleOnChange(ActionFilter.Download)}
            onChangeSearch={handleOnChange(ActionFilter.Search)}
            closeModal={closeModalInput}
            showModal={showModalInput}
            showDownload={dataTransHistory.length && isShowTable ? true : false}
            statusArray={statusArray}
            onReset={handleOnChange(ActionFilter.Reset)}
          />
          <TransactionTable data={dataList} onChangeData={getDateFromTable} isShow={isShowTable} />
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default ListTransactionHistory;
